<div class="mat-spinner-wrapper">
  <mat-spinner></mat-spinner>
</div>
